export default function (elementId, objectToSet, ref) {
  setTimeout(() => {
    const el = document.getElementById(elementId)
    if (el)
      el.addEventListener('scroll', () => {
        const calc = (el.scrollHeight - el.clientHeight) - el.scrollTop
        objectToSet[ref] = calc > 25
      })
  })
}